// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PythonPanelOptions-module__versionHistoryContainer--G1up6{box-shadow:0px 0px 4px 0px rgba(0,0,0,.25);border-radius:5px;overflow-y:auto;width:200px;max-height:calc(100vh - 480px)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"versionHistoryContainer": `PythonPanelOptions-module__versionHistoryContainer--G1up6`
};
module.exports = ___CSS_LOADER_EXPORT___;
